import { createFileRoute, redirect } from '@tanstack/react-router';

// `/chatbot/:id/atendimento` do legado (router.tsx:770-773) vira a aba `?tab=atendimento` (U42).
export const Route = createFileRoute('/_app/chatbot/$id/atendimento/')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- o redirect do TanStack Router é lançado
    throw redirect({ to: '/chatbot/$id', params: { id: params.id }, search: { tab: 'atendimento' }, replace: true });
  },
});
